import Flickity from 'flickity-fade';

const Slideshow = {
  init: () => {
    var slideshowObject = {
      cellSelector: '.js-slide',
      cellAlign: 'left',
      setGallerySize: false,
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      percentPosition: false,
      draggable: false,
      selectedAttraction: 0.015,
      friction: 0.25,
      lazyLoad: false
    };

    var homeSlideshowObject = {
      cellSelector: '.js-slide',
      cellAlign: 'left',
      setGallerySize: false,
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      percentPosition: false,
      draggable: false,
      selectedAttraction: 0.015,
      friction: 0.25,
      lazyLoad: false,
      fade: true
    }

    Slideshow.slideshows = document.querySelectorAll('.js-slideshow');
    Slideshow.menuButtons = document.querySelectorAll('.js-menuButton');
    Slideshow.slides = document.querySelectorAll('.js-slide');
    Slideshow.slideshows.forEach(slideshow => {
      const carousel = slideshow.classList.contains('slideshow--home') ? Slideshow.flickity(slideshow, homeSlideshowObject, 5000) : Slideshow.flickity(slideshow, slideshowObject, 4000);
    });
  },
  flickity: (element, options, timing) => {
    Slideshow.slider = new Flickity(element, options);
    window.clearTimeout(Slideshow.intervalSlide);
    Slideshow.intervalSlide = window.setTimeout(function(){
      var selected = Slideshow.slider.selectedElement;
      if (selected.getElementsByTagName('video').length == 0) {
        Slideshow.slider.next('true');
      }
    }, timing);
    Slideshow.slider.on( 'change', function( index ) {
      window.clearTimeout(Slideshow.intervalSlide);
      Slideshow.intervalSlide = window.setTimeout(function(){
        var selected = Slideshow.slider.selectedElement;
        if (selected.getElementsByTagName('video').length == 0) {
          Slideshow.slider.next('true');
        }
      }, timing);
    });
    return Slideshow.slider;
  }, 
  resize: () => {
    if (Slideshow.slideshows && document.querySelector('.js-post').dataset.routerView != 'home' && document.querySelector('.js-post').dataset.routerView != 'projectgrid' && document.querySelector('.js-post').dataset.routerView != 'actualites') {
      let buttons = document.querySelectorAll('.flickity-button');
      if (Slideshow.slides.length > 1) {
        document.querySelector('.slide.is-selected').nextElementSibling != null ? document.querySelector('.slide.is-selected').nextElementSibling.style.opacity = "0" : Slideshow.slides[0].style.opacity = "0"; 
      }
      buttons.forEach(button => { button.classList.add('disable'); })
      setTimeout(function(){
        Slideshow.slider.pausePlayer();
        Slideshow.slider.resize();
        Slideshow.slider.playPlayer();
      }, 600);   
      setTimeout(function(){
        Slideshow.slides.forEach(slide => { slide.style.opacity = "1"; })
        buttons.forEach(button => { button.classList.remove('disable'); })
      }, 1200) 
    }
  }
};

export default Slideshow;
